interface DiamondForCharlotteProps {
  className?: string;
  fillColor?: string;
}

export const DiamondForCharlotte = ({
  className,
  fillColor = "#008766",
}: DiamondForCharlotteProps) => {
  return (
    <svg
      className={className}
      width="33"
      height="31"
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="22"
        height="22"
        transform="matrix(0.733378 0.679821 -0.733378 0.679821 16.1346 0.275848)"
        fill={fillColor}
      />
    </svg>
  );
};
